// 首页静态展示数据（演示用，不接接口）

export const quickTopics: string[] = [
  "爆款古装剧大结局收视再创新高，片尾彩蛋埋了三季伏笔",
  "顶流综艺新一季官宣导师阵容，话题讨论量一夜破亿",
  "老牌乐队时隔八年合体开巡演，首站门票三分钟售罄",
  "悬疑电影密钥延期两周，片方加映幕后制作特辑",
  "新生代演员凭借口碑之作斩获年度新锐称号",
  "国民综艺回归，首期飞行嘉宾名单藏了反向彩蛋",
];

export interface GameCard {
  tag: string;
  title: string;
  desc: string;
  qcount: string;
  players: string;
  level: string;
  image: string;
}

export const gameCards: GameCard[] = [
  {
    tag: "轻量开胃",
    title: "吃瓜王答题",
    desc: "每场 8 道、每题 20 秒，影视综艺实时热点快问快答，饭点排队也能随手刷一局。",
    qcount: "累计 12,800+ 题",
    players: "386 万人已玩",
    level: "适合 刚入圈",
    image:
      "https://readdy.ai/api/search-image?query=fast%20fun%20quiz%20game%20interface%20scene%20with%20a%20single%20glowing%20play%20button%20and%20sparkling%20confetti%20burst%2C%20warm%20red%20and%20gold%20editorial%20pop%20art%20style%2C%20clean%20minimal%20flat%20illustration%2C%20soft%20gradient%20background%2C%20consistent%20brand%20palette&width=640&height=400&seq=game-quiz-01&orientation=landscape",
  },
  {
    tag: "认知照妖镜",
    title: "吃瓜王测试",
    desc: "从剧集名场面到幕后冷知识，一次性摸清你的八卦知识储备，解锁属于你的「吃瓜人格」。",
    qcount: "6 大人格标签",
    players: "212 万人已测",
    level: "适合 考考眼力",
    image:
      "https://readdy.ai/api/search-image?query=personality%20test%20result%20card%20with%20colorful%20grading%20meter%20and%20badge%20icons%20flying%2C%20playful%20editorial%20illustration%2C%20warm%20crimson%20and%20gold%20tones%2C%20minimal%20flat%20vector%20art%2C%20soft%20clean%20background&width=640&height=400&seq=game-test-02&orientation=landscape",
  },
  {
    tag: "心跳加速",
    title: "吃瓜王闯关",
    desc: "阶梯式连答不设防，连过 7 关登顶当期「瓜王」，中途答错即回到起点，越到后面越上头。",
    qcount: "单季 50 关",
    players: "149 万人挑战",
    level: "适合 高阶玩家",
    image:
      "https://readdy.ai/api/search-image?query=towering%20level%20ladder%20game%20with%20glowing%20stairs%20and%20a%20flag%20at%20the%20top%2C%20excitement%20and%20competition%20mood%2C%20warm%20red%20and%20gold%20editorial%20pop%20art%2C%20minimal%20flat%20vector%2C%20clean%20gradient%20background&width=640&height=400&seq=game-tower-03&orientation=landscape",
  },
  {
    tag: "深度考古",
    title: "吃瓜王考察",
    desc: "限定主题开卷考：一段古早访谈、一句名台词出处、一条幕后旧闻，资深粉丝的终极考场。",
    qcount: "每周上新 20 卷",
    players: "62 万人应考",
    level: "适合 考古党",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20examination%20desk%20scene%20with%20old%20film%20reels%20and%20antique%20microphone%2C%20nostalgic%20archaeology%20mood%2C%20warm%20sepia%20red%20and%20gold%20editorial%20style%2C%20minimal%20flat%20illustration%2C%20soft%20clean%20background&width=640&height=400&seq=game-exam-04&orientation=landscape",
  },
];

export interface FeedItem {
  time: string;
  hot: boolean;
  cat: string;
  catColor: string;
  title: string;
  text: string;
  comment: string;
  likes: string;
  replies: string;
  image: string;
}

export const feedItems: FeedItem[] = [
  {
    time: "12:46",
    hot: true,
    cat: "今晚瓜棚",
    catColor: "text-primary-600",
    title: "「名场面翻拍挑战」上线，谁是你心中的满分还原？",
    text: "新一轮吃瓜王闯关来了，本期考古经典影视桥段，请凭记忆判断真实与错位台词。",
    comment: "「第 3 题差点翻车，一秒梦回追剧那年」",
    likes: "2.4万",
    replies: "1.8k",
    image:
      "https://readdy.ai/api/search-image?query=cinema%20retro%20scene%20with%20clapperboard%20and%20film%20spotlight%2C%20nostalgic%20warm%20editorial%20pop%20art%20illustration%2C%20crimson%20and%20gold%20palette%2C%20minimal%20flat%20vector%2C%20clean%20soft%20background&width=360&height=300&seq=feed-scene-05&orientation=squarish",
  },
  {
    time: "11:02",
    hot: false,
    cat: "热梗速递",
    catColor: "text-accent-700",
    title: "一个表情包引发全网认领，你站哪一派的嘴替？",
    text: "近期话题讨论直冲热榜，吃瓜王测试新增「嘴替等级」分支，快来看看你够不够懂梗。",
    comment: "「好家伙，正确答案居然是我舍友天天说的那句」",
    likes: "1.1万",
    replies: "932",
    image:
      "https://readdy.ai/api/search-image?query=speech%20bubbles%20and%20meme%20stickers%20collage%20floating%20playfully%2C%20vibrant%20warm%20editorial%20pop%20art%2C%20red%20and%20gold%20palette%2C%20minimal%20flat%20illustration%2C%20clean%20soft%20background&width=360&height=300&seq=feed-meme-06&orientation=squarish",
  },
  {
    time: "09:40",
    hot: true,
    cat: "瓜田快讯",
    catColor: "text-primary-600",
    title: "限时开卷：30 秒认全老剧十大黄金配角",
    text: "吃瓜王考察本周特别卷已开，题目难度适中，通关即可点亮「老剧十级学者」徽章。",
    comment: "「做了三遍终于满分，谁懂这种胜负欲」",
    likes: "8.9k",
    replies: "604",
    image:
      "https://readdy.ai/api/search-image?query=golden%20supporting%20actor%20collage%20with%20vintage%20tv%20frames%20and%20warm%20spotlights%2C%20editorial%20pop%20art%2C%20crimson%20gold%20palette%2C%20minimal%20flat%20vector%2C%20clean%20background&width=360&height=300&seq=feed-gold-07&orientation=squarish",
  },
  {
    time: "08:15",
    hot: false,
    cat: "数据瓜田",
    catColor: "text-accent-700",
    title: "昨晚热搜榜复盘：这条话题为何霸榜一整夜？",
    text: "用数据回看每一条热议的起承转合，边吃瓜边涨知识，答题前先来补补课。",
    comment: "「原来热度峰值出现在晚间九点，涨知识了」",
    likes: "6.2k",
    replies: "377",
    image:
      "https://readdy.ai/api/search-image?query=rising%20trend%20chart%20with%20glowing%20bar%20graph%20and%20megaphone%2C%20analytics%20mood%2C%20warm%20red%20and%20gold%20editorial%20pop%20art%2C%20minimal%20flat%20illustration%2C%20clean%20soft%20background&width=360&height=300&seq=feed-data-08&orientation=squarish",
  },
];

export interface Comment {
  user: string;
  tag: string;
  level: string;
  text: string;
  likes: string;
  replies: string;
  tone: "praise" | "hot" | "funny";
}

export const hotComments: Comment[] = [
  {
    user: "糖霜小圆子",
    tag: "本季瓜王",
    level: "闯关 37/50",
    text: "连答十题没断，靠的全是当年追剧攒下的童子功，这波属实是专业对口了。",
    likes: "5.6万",
    replies: "842",
    tone: "praise",
  },
  {
    user: "夜宵加一勺",
    tag: "吃瓜新人",
    level: "测试 62 分",
    text: "第 7 题真的会谢，选项长得跟双胞胎似的，求题目组下次别太狠。",
    likes: "3.9万",
    replies: "1.2k",
    tone: "funny",
  },
  {
    user: "瓜皮但甜",
    tag: "考古十级",
    level: "考察 A 卷满分",
    text: "这题引用的那段访谈我昨晚刚二刷过，四舍五入这就是送分题，感恩老剧永不过时。",
    likes: "4.1万",
    replies: "977",
    tone: "hot",
  },
  {
    user: "风里追番",
    tag: "本季瓜王",
    level: "闯关 41/50",
    text: "跟朋友拼手速互怼了一晚上，谁先答错谁请奶茶，结局是我请了两轮，但真的快乐。",
    likes: "2.7万",
    replies: "655",
    tone: "funny",
  },
];

export interface Tier {
  name: string;
  range: string;
  desc: string;
  tone: string;
  icon: string;
}

export const tiers: Tier[] = [
  { name: "瓜田路人", range: "0 – 200 分", desc: "刚摸到瓜田边，先来两局答题找找手感", tone: "bg-secondary-100 text-secondary-900 border-secondary-200", icon: "ri-roadster-line" },
  { name: "资深看客", range: "200 – 500 分", desc: "能接住大多数热梗，饭圈黑话略懂一二", tone: "bg-background-100 text-foreground-700 border-background-200", icon: "ri-eye-line" },
  { name: "冲浪老手", range: "500 – 900 分", desc: "名场面如数家珍，测试人格稳定输出", tone: "bg-accent-100 text-accent-900 border-accent-200", icon: "ri-star-line" },
  { name: "瓜王本王", range: "900 分以上", desc: "登顶段位榜首，下一届瓜王由你来卷", tone: "bg-primary-500 text-background-50 border-primary-500", icon: "ri-medal-line" },
];

export interface Fact {
  title: string;
  text: string;
  tag: string;
  image: string;
}

export const facts: Fact[] = [
  {
    title: "为什么「重金求瓜」总爱深夜放送",
    text: "很多热议多在晚间九点后迎来第一波高峰，追完当天的剧正好接上讨论节奏，第二天一早正好复盘补课。",
    tag: "数据观察",
    image:
      "https://readdy.ai/api/search-image?query=late%20night%20city%20glow%20with%20phone%20screen%20showing%20trending%20topic%20under%20moonlight%2C%20editorial%20pop%20art%2C%20warm%20crimson%20and%20gold%20palette%2C%20minimal%20flat%20illustration%2C%20soft%20clean%20background&width=420&height=320&seq=fact-night-09&orientation=landscape",
  },
  {
    title: "一条名台词能养活多少道吃瓜王题目",
    text: "经典台词自带画面与情绪，是最容易出题也最容易设陷阱的素材，本期闯关有近三成题都和名场面有关。",
    tag: "选题内幕",
    image:
      "https://readdy.ai/api/search-image?query=quote%20lines%20unfolding%20from%20a%20film%20frame%20with%20golden%20light%2C%20editorial%20pop%20art%2C%20warm%20red%20and%20gold%20palette%2C%20minimal%20flat%20illustration%2C%20clean%20background&width=420&height=320&seq=fact-line-10&orientation=landscape",
  },
  {
    title: "答题为什么会越答越上头",
    text: "短时反馈加连续通关的小确幸，是让人停不下来的关键。吃瓜王闯关把奖励切成小块，每到新关都想再点一下。",
    tag: "心理小灶",
    image:
      "https://readdy.ai/api/search-image?query=playful%20brain%20with%20spark%20and%20reward%20stars%20glowing%2C%20curiosity%20mood%2C%20warm%20crimson%20and%20gold%20editorial%20pop%20art%2C%20minimal%20flat%20vector%2C%20clean%20background&width=420&height=320&seq=fact-brain-11&orientation=landscape",
  },
];

export const topicStats: { label: string; pct: string; hint: string }[] = [
  { label: "影视综名场面", pct: "38%", hint: "出题比例最高" },
  { label: "音乐舞台与现场", pct: "24%", hint: "考验耳力" },
  { label: "艺人考古往事", pct: "21%", hint: "老粉主场" },
  { label: "互联网流行梗", pct: "17%", hint: "冲浪必备" },
];

export const heroStats: { value: string; label: string }[] = [
  { value: "1200+", label: "实时题库" },
  { value: "861万", label: "累计答题" },
  { value: "37 关", label: "本期最高闯关" },
];